// removed by extract-text-webpack-plugin
module.exports = {"link":"_1GKEVbGiHOPif2wkRmfTha","white":"_2F-iXkc0C7mPd-nn7j_dSs","gray":"_2oTErwKAErGxK0bCs8i5Bw","amplified":"DVanegLzpBFaQ_STSMJk5"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/link/link.scss
// module id = 418
// module chunks = 0